import { configureStore } from '@reduxjs/toolkit'
import cartReducer from './features/cartSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'

// Persist Config
const persistConfig = {
  key: 'root',
  storage,
}

// Combine reducers if needed
const rootReducer = combineReducers({
  cart: cartReducer,
})

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

// ✅ Correct middleware syntax
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disabling serializable check for redux-persist
    }),
})

// Persistor to persist the store
export const persistor = persistStore(store)

export default store
